import { OWNED_CONTENT, PRESERVED_ATTRIBUTES, preservesOwnState } from "./morph_state"

function buildsItsOwnChildren(element) {
  return element.matches(OWNED_CONTENT)
}

function skipSubtreesWhoseChildrenTheClientBuilds(event) {
  const element = event.target
  if (!(element instanceof HTMLElement)) return
  if (!buildsItsOwnChildren(element)) return

  event.preventDefault()
}

function holdsUnsavedInput(element) {
  const editable = element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement
  return editable && element.value !== element.defaultValue
}

function keepUnsavedInputTheReaderHasTyped(event) {
  const { attributeName } = event.detail
  if (attributeName !== "value") return false
  if (!holdsUnsavedInput(event.target)) return false

  event.preventDefault()
  return true
}

function keepTheStateTheClientOwns(event) {
  const { attributeName } = event.detail
  if (!PRESERVED_ATTRIBUTES.includes(attributeName)) return
  if (!preservesOwnState(event.target)) return

  event.preventDefault()
}

export function startMorphGuard() {
  document.addEventListener("turbo:before-morph-element", skipSubtreesWhoseChildrenTheClientBuilds)

  document.addEventListener("turbo:before-morph-attribute", (event) => {
    if (keepUnsavedInputTheReaderHasTyped(event)) return

    keepTheStateTheClientOwns(event)
  })
}
